<nav class="navbar navbar-expand-md fixed-top ds-hd-nav">
  <div class="container-fluid">
  <div class="ds-hd-brand">
    <a class="ds-hd-logo" href="https://www.myhcl.com/"><img src="assets/images/hcltech.svg" alt="HCLTech"></a>
    <a class="ds-hd-app" routerLink="/approval">Common Delegation System</a>
  </div>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarCollapse">
      <ul class="ds-hd-right">
        <li class="ds-hd-appiosandrd">
          <button class="btn btn-secondary dropdown-toggle" type="button" aria-expanded="false">
            <!-- <img src="assets/images/App.gif" alt="App Icon"> -->
          </button>
        </li>
        <li dropdown [insideClick]="true" *ngIf="IsShowHeaderDeatils">
          <button class="btn btn-secondary dropdown-toggle" type="button" aria-expanded="false" aria-label="Help Center" dropdownToggle>
            <i class="hdr-help"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-end ds-hd-helpcenter" *dropdownMenu>
            <h4 class="ds-hd-heading">Help Center</h4>
            
            <ul class="ds-hd-tophelp">
              <li *ngFor="let item of topHelpNav">
                <a href="../../../assets/images/Common Delegation System-ManualDocument.docx" download=""><i class="{{item.icon}}"></i>{{item.name}}</a>
              </li>
            </ul>
          </div>
        </li>
        <!-- <li dropdown [insideClick]="true">
          <button class="btn btn-secondary dropdown-toggle" type="button" aria-expanded="false"
            aria-label="My Favourites" dropdownToggle>
            <i class="hdr-myFav"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-end ds-hd-favorite" *dropdownMenu>
            <h4 class="ds-hd-heading">My Favourites <a href="#" class="ds-hd-favedit"><i class="hdr-edit"></i></a></h4>
            <ul class="ds-hd-role ds-hd-favrole">

              <li *ngFor="let item of myFavlist">
                <a href={{item.url}}> <i class="{{item.icon}}"></i> {{item.name}}</a>
              </li>

            </ul>
          </div>
        </li> -->
        <li dropdown [insideClick]="true" *ngIf="IsShowHeaderDeatils">
          <button class="btn btn-secondary dropdown-toggle" type="button" aria-expanded="false" aria-label="Menu" dropdownToggle>
            <i class="hdr-internal-nav"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-end ds-hd-navmenu" *dropdownMenu role="menu">
            <ul class="ds-hd-role">
               <li><a routerLink="/">Home</a></li> 
               <li><a routerLink="/approval">Approvals Dashboard </a></li>
               <li *ngIf="DelegationMenuacess"><a routerLink="/delegationReports">Delegation Report </a></li>
               <!-- <li><a routerLink="/delegationReports">Delegation Report </a></li> -->
               <li><a routerLink="/advanceDeligation">Advance Delegation Request </a></li>  
               <li><a routerLink="/onBehalfDelegation">Exceptional Delegation</a></li>  
               <!-- <li><a routerLink="/configureRole">Configure Role </a></li>  -->
            </ul>
            
          </div>
        </li>
        <li class="ds-hd-empsec" dropdown [insideClick]="true">
          <button class="btn btn-secondary dropdown-toggle" type="button" aria-expanded="false" dropdownToggle>
            <span class="ds-hd-sap">{{SapId}} <span class="ds-hd-emp">Employee</span></span>
            <span class="ds-hd-name">{{TitleName | slice:0:2}}</span>
          </button>
          <div class="dropdown-menu dropdown-menu-end ds-hd-empd" *dropdownMenu role="menu" >
            <div class="ds-hd-fullempname">
              <h5> {{EmployeeName}} </h5>
              <p>{{SapId}}<span class="ds-hd-emprole">{{Designation}}</span></p>
            </div>
            <h5 class="ds-hd-changerole">Change Role <i class="hdr-changeRole"></i></h5>
            <ul class="ds-hd-role ds-hd-userole">
              <li class="active"><a href="#">Employee</a></li>
              <!-- <li><a href="#">Approver</a></li>
              <li><a href="#">BPO Head</a></li>
              <li><a href="#">Admin</a></li> -->
            </ul>
            <!-- <button type="button" class="ds-hd-logout" routerLink="/Logout" (click)="openDialog(myDialog)"> Logout <i class="hdr-logOut"></i></button> -->
            <button type="button" class="ds-hd-logout" (click)="openDialog(alertTemp)"> Logout <i class="hdr-logOut"></i></button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>

      
  <!-- Feedback -->
  <!-- <ng-template #myDialog>
    <div class="m-header">
      <h2 class="m-title">Feedback!</h2>
      <h3   (click)="modalRef.hide()" class="closeM"><i class="hcl-close"></i></h3>
    </div>
    <div class="mBody">
      <div class="row rating">
        <div class="col-6">
          <rating [(ngModel)]="rate" [max]="max" [readonly]="isReadonly" (onLeave)="handleRate($event)" class="ratingN">
          </rating>
        </div>
        <div class="col-6">
          <h2>{{msg}} </h2>
        </div>
      </div>
      <textarea class="textarea" placeholder="Provide your remarks here"></textarea>
      <div class="text-center glb-btn mt-0"> <button type="button"  (click)="modalRef.hide()" (click)="openDialog(approvedModal)"  class="btn primary-button">Submit</button></div>
      <button  type="button" class="btn primary-button" (click)="rejectModal.hide(); openModal(approvedModal); addClassToBody()">Submit</button>
    </div>
  </ng-template>  -->
      
  <!-- Reject Modal Box Start  -->
  <div bsModal #rejectModal="bs-modal" class="modal fade myModal" tabindex="-1" role="dialog" aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-lg">
    <div class="modal-content">
    <div class="modal-header">
      <h2 class="m-title">Feedback!</h2>
        <button type="button" class="btn-close close pull-right" (click)="rejectModal.hide()" aria-label="Close">
        <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
    </div>
    <div class="modal-body">
      <div class="row rating">
        <div class="col-6">
          <rating [(ngModel)]="rate" [max]="max" [readonly]="isReadonly" (onLeave)="handleRate($event)" class="ratingN">
          </rating>
        </div>
        <div class="col-6">
          <h2>{{msg}} </h2>
        </div>
      </div>
      <textarea class="textarea" placeholder="Provide your remarks here"></textarea>
        <div class="form-area text-center">
         
          <div class="glb-btn mt-10">
            <button  type="button" class="btn primary-button" (click)="rejectModal.hide(); openModal(approvedModal); ">Submit</button>
          </div>
        </div>
    </div>
    </div>
    </div>
</div> 



<!-- alertTemp -->
<ng-template #alertTemp>
  <div class="mtable">
      <div class="mCell">
          <h4 (click)="modalRef.hide()" class="closeS"></h4>
          <span class="alertIcon"> <i class="hdr-attention"></i> </span>
          <h3>Are you sure you want to logout?</h3>
          <div class="glb-btn mt-48 glb-btn">
              <button (click)="modalRef.hide()" class="btn secondry-button">No</button>
              <button (click)="modalRef.hide()" routerLink="/Logout" class="btn primary-button">Yes</button>
          </div>
      </div>
  </div>
</ng-template>

  <!-- Approve Modal Box Start  -->
  <!-- <ng-template #approvedModal>
    <div class="modal-body successModal">
        <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
          </button>
        <div class="mtable">
            <span class="sucImg"> <img width="60" height="60" alt="approve Image" [src]="sucImg" />  </span>
          <p class="">Request has been approved successfully.</p>
        </div>
    </div>
  </ng-template> -->

    <!-- Approve Modal Box Start  -->
    <ng-template #approvedModal>
      <div class="modal-body successModal">
          <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide(); hideSuccessMsg()">
              <span aria-hidden="true" class="visually-hidden">&times;</span>
            </button>
          <div class="mtable">
              <span class="sucImg"> <img width="60" height="60" alt="approve Image" [src]="sucImg" />  </span>
            <p class="">Request has been approved successfully.</p>
          </div>
      </div>
    </ng-template>

    <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
      <p style="font-size: 20px; color: white">Loading...</p>
    </ngx-spinner>
    

